import Qs from 'qs'
import service from '@/services/service'
import { APIMenu } from '@/models/api/menu.model'

const resource = {
    main: 'services',
    module: 'menus'
}

export class MenuServices {
    public static getMenu () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getMenuPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getMenuById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static createMenu (params: APIMenu) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static editMenu (params: APIMenu) {
        return service.put(`${resource.main}/${resource.module}/${params.id}`, params)
    }

    public static deleteMenu (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }
}
